import React, { ReactNode } from 'react';
import ExitIcon from '@moda/icons/exit-16';
import WarningIcon from '@moda/icons/warning-20';
import { colors } from '@moda/tokens';
import { TextColor, Stack, Clickable, Text } from '@moda/om';
import { Box } from '../Box';
import './CheckoutNotification.scss';

type CheckoutNotificationProps = {
  color?: TextColor;
  title: ReactNode;
  onClose: () => void;
  children?: ReactNode;
};

export const CheckoutNotification: React.FC<CheckoutNotificationProps> = ({
  color,
  title,
  onClose,
  children
}) => (
  <Box className="CheckoutNotification">
    <Stack direction="horizontal" space={3} justifyContent="space-between">
      <Stack direction="horizontal" space={2}>
        <WarningIcon
          className="CheckoutNotification__warning-icon"
          color={color && colors.all[color]}
        />
        <Text color={color}>{title}</Text>
      </Stack>
      <Clickable aria-label="Close" onClick={onClose}>
        <ExitIcon />
      </Clickable>
    </Stack>
    {children}
  </Box>
);
